import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.object.keys.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Drip from 'drip';
import Store from 'drip/store';
import User from 'drip/user';
import Event from 'drip/event';
import KNB from '@dp/knb';
import OpenItem from './open-item.vue';
import { copyTextToClipboard } from '@/utils/';
var envList = ['product', 'beta', 'dev'];
var urlList = [{
  title: '首页',
  url: 'http://h5.51ping.com/app/myshow/'
}, {
  title: '列表页',
  url: 'http://h5.51ping.com/app/myshow/#/list/0'
}, {
  title: '搜索页',
  url: 'http://h5.51ping.com/app/myshow/#/search/'
}, {
  title: '订单列表页',
  url: 'http://h5.51ping.com/app/myshow/#/order-list'
}];
export default {
  // 开发面板页
  name: 'debugger',
  components: {
    'open-item': OpenItem
  },
  data: function data() {
    var swimlane = '';
    // href 中获取泳道地址
    var match = /https?:\/\/(.*)-h5\.51ping\.com.*/ig.exec(location.href);
    if (match && match[1]) {
      swimlane = match[1];
    }
    return {
      // 泳道地址
      swimlane: swimlane,
      // 常用url列表
      urlList: [],
      addUrl: '',
      addUrlTitle: '',
      // 用户信息
      userInfo: null
    };
  },
  created: function created() {
    this.setOpenList();
    this.setUserInfo();
  },
  methods: {
    quickSwtich: function quickSwtich(e) {
      var env = e.target.dataset.env;
      if (!envList.includes(env)) return;
      if (env === 'product') {
        location.href = 'https://h5.dianping.com/app/myshow/#/';
      } else if (env === 'beta') {
        this.swimlane = '';
        this.openWithSwimlane();
      } else {
        this.swimlane = '3803-aakmg';
        this.openWithSwimlane();
      }
    },
    openSwimlane: function openSwimlane() {
      if (!this.swimlane) return;
      this.openWithSwimlane();
    },
    openUrl: function openUrl(e) {
      var url = e.target.dataset.url;
      this.openWithSwimlane(url);
    },
    openWithSwimlane: function openWithSwimlane() {
      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : location.href;
      var swimlane = this.swimlane;
      var _URL = new URL(url),
        protocol = _URL.protocol,
        hostname = _URL.hostname,
        pathname = _URL.pathname,
        search = _URL.search,
        hash = _URL.hash;
      location.href = "".concat(protocol, "//").concat(swimlane ? swimlane + '-' : '', "h5.51ping.com").concat(pathname).concat(search).concat(hash);
    },
    addOpenUrl: function addOpenUrl() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var addUrlList;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(!_this.addUrlTitle || !_this.addUrl)) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              _context.next = 4;
              return Store.get('url-list');
            case 4:
              _context.t0 = _context.sent;
              if (_context.t0) {
                _context.next = 7;
                break;
              }
              _context.t0 = [];
            case 7:
              addUrlList = _context.t0;
              addUrlList.push({
                title: _this.addUrlTitle,
                url: _this.addUrl
              });
              Store.set('url-list', addUrlList);
              _this.setOpenList();
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    setOpenList: function setOpenList() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var addUrlList;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return Store.get('url-list');
            case 2:
              _context2.t0 = _context2.sent;
              if (_context2.t0) {
                _context2.next = 5;
                break;
              }
              _context2.t0 = [];
            case 5:
              addUrlList = _context2.t0;
              _this2.urlList = urlList.concat(addUrlList);
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    setUserInfo: function setUserInfo() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var userInfo;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return User.getUserInfo();
            case 2:
              _context3.t0 = _context3.sent;
              if (_context3.t0) {
                _context3.next = 5;
                break;
              }
              _context3.t0 = {};
            case 5:
              userInfo = _context3.t0;
              _this3.userInfo = Object.keys(userInfo).reduce(function (obj, key) {
                var value = userInfo[key];
                if (value !== undefined && value !== '') {
                  obj[key] = value;
                }
                return obj;
              }, {});
            case 7:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    copyItem: function copyItem(e) {
      var value = e.target.dataset.item;
      if (!value) return;
      var success = copyTextToClipboard(value);
      if (success) {
        this.$toast('复制成功');
      }
    },
    userLogin: function userLogin() {
      if (this.userInfo.isLogin) {
        User.logout();
      } else {
        User.login();
      }
    },
    // 打开扫一扫
    openScan: function openScan() {
      var _this4 = this;
      var open = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      KNB.scanQRCode({
        needResult: open ? 0 : 1,
        success: function success(res) {
          if (!open) {
            _this4.addUrl = res.scanResult;
          }
        }
      });
    }
  }
};